
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    totalAdReport:0,
    adReportListing:[],
    adReportDetail:null
  };
  
  const adReportReducer = (state = initialState, action) => {
    console.log("ad report reducers------", state,action);
   switch (action.type) {
     case "ADD_AD_REPORT_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_AD_REPORT_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_AD_REPORT_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_AD_REPORT_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_AD_REPORT_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_AD_REPORT_REQUEST_SUCCESS":
        return {
          ...state,
          adReportListing: action.payload,
          totalAdReport:action.total,
          loading:false,
        };

      case "GOT_AD_REPORT_DETAIL":  
      return {
        ...state,
        adReportDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default adReportReducer;
  